import type { MessageKeys } from 'next-intl';
import type { Messages } from '@/global';
import differenceInDays from 'date-fns/differenceInDays';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import { useFormatter, useTranslations } from 'next-intl';
import appConst from '~/const/appConst';

export const getTranslationKey = ({
  displayDay = false,
  isSameYear,
  isSameMonth,
  daysBetween,
}: GetTranslationKeyArgs): MessageKeys<
  Messages,
  | 'GLOBAL.DATE_WITH_DAY_2'
  | 'GLOBAL.DATE_WITHOUT_DAY_2'
  | 'GLOBAL.DATE_WITH_DAY_3'
  | 'GLOBAL.DATE_WITHOUT_DAY_3'
  | 'GLOBAL.DATE_WITH_DAY_4'
  | 'GLOBAL.DATE_WITHOUT_DAY_4'
  | 'GLOBAL.DATE_WITH_DAY_1'
  | 'GLOBAL.DATE_WITHOUT_DAY_1'
> => {
  if (isSameYear && !isSameMonth)
    return displayDay ? 'GLOBAL.DATE_WITH_DAY_2' : 'GLOBAL.DATE_WITHOUT_DAY_2';

  if (isSameYear && isSameMonth) {
    if (daysBetween > 0) {
      return displayDay
        ? 'GLOBAL.DATE_WITH_DAY_3'
        : 'GLOBAL.DATE_WITHOUT_DAY_3';
    }
    return displayDay ? 'GLOBAL.DATE_WITH_DAY_4' : 'GLOBAL.DATE_WITHOUT_DAY_4';
  }
  return displayDay ? 'GLOBAL.DATE_WITH_DAY_1' : 'GLOBAL.DATE_WITHOUT_DAY_1';
};

export const FormatedDateslot = ({
  start,
  end,
  displayDay = false,
}: FormatedDateslotProps) => {
  const beginDate = new Date(start);
  const endDate = new Date(end);
  const isSameYear = getYear(beginDate) - getYear(endDate) === 0;
  const isSameMonth = getMonth(beginDate) - getMonth(endDate) === 0;
  const daysBetween = differenceInDays(endDate, beginDate);
  const t = useTranslations();
  const format = useFormatter();

  const key = getTranslationKey({
    displayDay,
    isSameYear,
    isSameMonth,
    daysBetween,
  });

  return (
    <>
      {t(key, {
        beginDate: format.dateTime(
          new Date(start),
          appConst.dateFormat.date,
        ),
        beginDateDay: format.dateTime(
          new Date(start),
          appConst.dateFormat.day,
        ),
        beginDateDayMonth: format.dateTime(
          new Date(start),
          appConst.dateFormat.monthNumeric,
        ),
        beginDateDayOnly: format.dateTime(
          new Date(start),
          appConst.dateFormat.dayNumeric,
        ),
        endDateDay: format.dateTime(
          new Date(end),
          appConst.dateFormat.day,
        ),
        endDate: format.dateTime(
          new Date(end),
          appConst.dateFormat.weekDayDate,
        ),
      })}
    </>
  );
};

export interface FormatedDateslotProps {
  start: string;
  end: string;
  displayDay?: boolean;
}

export interface GetTranslationKeyArgs {
  displayDay: boolean;
  isSameYear: boolean;
  isSameMonth: boolean;
  daysBetween: number;
}
